import { FC, PropsWithChildren } from "react";
import {
  FormControl,
  FormControlProps,
  Select,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { ControllerProps } from "react-hook-form";
import CustomLabelInput from "@components/CustomLabelInput";

interface ReactHookFormSelectProps extends FormControlProps {
  label: string;
  placeholder?: string;
  displayValueFunction?: (v: string) => string;
  controller: Omit<ControllerProps<any>, "render">;
}

const ReactHookFormSelect: FC<PropsWithChildren<ReactHookFormSelectProps>> = ({
  label,
  placeholder,
  displayValueFunction,
  controller,
  children,
  ...props
}) => {
  const labelId = `${controller.name}-label`;
  return (
    <CustomLabelInput label={label} labelId={labelId} required={props.required}>
      <FormControl {...props}>
        <Controller
          render={({ field }) => (
            <Select
              {...field}
              defaultValue={controller.defaultValue}
              labelId={labelId}
              sx={{ textAlign: "left" }}
              fullWidth={true}
              displayEmpty
              renderValue={(value: string) => {
                if (!value && placeholder) {
                  return (
                    <Typography
                      textOverflow="ellipsis"
                      overflow="hidden"
                      color="rgba(0, 0, 0, 0.4)"
                      fontSize="16px"
                    >
                      {placeholder}
                    </Typography>
                  );
                }
                return (
                  <>
                    {displayValueFunction ? displayValueFunction(value) : value}
                  </>
                );
              }}
            >
              {children}
            </Select>
          )}
          {...controller}
        />
      </FormControl>
    </CustomLabelInput>
  );
};

export default ReactHookFormSelect;
